import React from "react";
import {SectionDetail, TitleSection, TitleContainer, InfoDetail} from "./Styles";
import {Content} from "../../../styles/GlobalStyles";

export default function DetailsComponent({title, children, iconTitle, column, full, classname, iconClass, titleClass}) {
   return (
      <SectionDetail className={classname}>
         <Content className="child">
            {title && (
               <TitleContainer className={titleClass}>
                  <img src={iconTitle} alt={title} className={`${iconClass} titleIcon`} />
                  <TitleSection>{title}</TitleSection>
               </TitleContainer>
            )}
            <InfoDetail full={full} column={column}>
               {children}
            </InfoDetail>
         </Content>
      </SectionDetail>
   );
}

DetailsComponent.defaultProps = {
   column: false,
   full: false,
};
